export default __webpack_public_path__ + "static/media/plan.dd68f0a4.svg";